<template>
  <el-dialog
    title="查看详情"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="order-details" v-loading="loading">
      <!-- Tab 切换 -->
      <div class="tab-header">
        <span :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">系统核保反馈</span>
        <span :class="{ active: tabIndex === 2 }" @click="tabIndex = 2">人工核保参考</span>
      </div>

      <!-- 系统核保反馈 -->
      <div v-show="tabIndex === 1" class="tab-content">
        <div class="detail-section">
          <div class="info-left">
            <div class="info-item">
              <label>被投保人名称：</label>
              <span>{{ orderInfo.policyholder }}</span>
            </div>
            <div class="info-item">
              <label>累计限额(万元)：</label>
              <span>{{ orderInfo.total_coverage }}</span>
            </div>
            <div class="info-item">
              <label>扩展需求：</label>
              <el-input type="textarea" :value="orderInfo.extend" disabled :rows="3" style="width: 250px;"></el-input>
            </div>
            <div class="info-item">
              <label>备注：</label>
              <el-input type="textarea" :value="orderInfo.note" disabled :rows="3" style="width: 250px;"></el-input>
            </div>
            <div class="info-item">
              <label>经营范围：</label>
              <el-input type="textarea" :value="orderInfo.business_scope" disabled :rows="3" style="width: 250px;"></el-input>
            </div>
            <div class="info-item">
              <label>直属渠道：</label>
              <span>{{ orderInfo.channel_name }}</span>
            </div>
          </div>
          <div class="info-right">
            <div class="info-item">
              <label>营收收入(万元)：</label>
              <span>{{ orderInfo.business_income }}</span>
            </div>
            <div class="info-item">
              <label>单次限额(万元)：</label>
              <span>{{ orderInfo.single_coverage }}</span>
            </div>
            <div class="info-item">
              <label>去年赔付情况：</label>
              <el-input type="textarea" :value="orderInfo.last_compensation" disabled :rows="3" style="width: 250px;"></el-input>
            </div>
            <div class="info-item">
              <label>注册地区：</label>
              <span>{{ orderInfo.province }} - {{ orderInfo.city }}</span>
            </div>
            <!-- 核保结果表格 -->
            <table class="result-table" v-if="preUnderwriteDetails.length">
              <thead>
                <tr>
                  <th>投保区域判断</th>
                  <th>承保关键字判断</th>
                  <th>系统核保结果</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in preUnderwriteDetails" :key="index">
                  <td>{{ !item.is_insured_area ? '√' : '×' }}</td>
                  <td>{{ !item.is_company_name_keywords ? '√' : '×' }}</td>
                  <td>{{ item.rejection_result ? '拒保' : '通过' }}</td>
                </tr>
              </tbody>
            </table>
            <!-- 附件 -->
            <div class="attachment-section" v-if="fileList.length">
              <p>查看附件：</p>
              <div class="file-grid">
                <div v-for="(item, index) in fileList" :key="index" class="file-item">
                  <img
                    v-if="!item.url.endsWith('.pdf')"
                    :src="item.url"
                    style="width: 60px; height: 60px; object-fit: cover; cursor: pointer;"
                    @click="previewImage(item.url)"
                  />
                  <a v-else :href="item.url" target="_blank" style="color: #409EFF; font-size: 12px;">
                    {{ item.url.split('/').pop() }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 人工核保参考 -->
      <div v-show="tabIndex === 2" class="tab-content manual-reference">
        <!-- 理赔案件信息 -->
        <div class="reference-section">
          <h3>|| 理赔案件信息</h3>
          <el-table :data="claimsOrderList" border size="small">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="status" label="案件进度" width="120" align="center" :formatter="scheduleFormat" />
            <el-table-column prop="policy_no" label="保单号码" width="150" align="center" />
            <el-table-column prop="product_name" label="产品名称" width="120" align="center" />
            <el-table-column label="出险货物/人员名称" width="160" align="center">
              <template slot-scope="{ row }">{{ row.cargo_name }}/{{ row.insurance_claims_people }}</template>
            </el-table-column>
            <el-table-column prop="risk_at" label="出险时间" width="120" align="center" :formatter="dateFormat" />
            <el-table-column prop="risk_reason" label="出险原因" width="120" align="center" show-overflow-tooltip />
            <el-table-column prop="paid_amount" label="实际赔偿金额" width="120" align="center" :formatter="moneyFormat" />
          </el-table>
        </div>

        <!-- 员工保历史数据 -->
        <div class="reference-section">
          <h3>|| 员工保历史数据</h3>
          <el-table :data="ygbOrderList" border size="small">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="policy_no" label="保单号码" width="150" align="center" />
            <el-table-column prop="insurer_company_name" label="保险公司" width="150" align="center" />
            <el-table-column prop="effected_at" label="起保时间" width="140" align="center" :formatter="dateTimeFormat" />
            <el-table-column prop="expired_at" label="终保时间" width="140" align="center" :formatter="dateTimeFormat" />
            <el-table-column label="人员构成" width="200" align="center">
              <template slot-scope="{ row }">司机押运{{ row.trucker_number }}；搬运工人{{ row.driver_number }}；文员内勤{{ row.clerk_number }}</template>
            </el-table-column>
            <el-table-column prop="total_changes" label="人员变更记录总计" width="130" align="center" />
            <el-table-column prop="weekly_change" label="周变更频次" width="100" align="center" />
            <el-table-column prop="monthly_change" label="月变更频次" width="100" align="center" />
          </el-table>
        </div>

        <!-- 货运险历史数据 -->
        <div class="reference-section">
          <h3>|| 货运险历史数据</h3>
          <el-table :data="hyxOrderList" border size="small">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="product_name" label="产品名称" width="120" align="center" />
            <el-table-column label="近三个月是否投保" width="130" align="center">
              <template slot-scope="{ row }">{{ row.is_insure ? '√' : '×' }}</template>
            </el-table-column>
            <el-table-column prop="total_single_quantity" label="总单量" width="100" align="center" />
            <el-table-column prop="monthly_average_unit_quantity" label="月平均单量" width="110" align="center" />
            <el-table-column prop="total_premium" label="总保费" width="100" align="center" :formatter="moneyFormat" />
            <el-table-column prop="average_monthly_premium" label="月平均保费" width="110" align="center" :formatter="moneyFormat" />
          </el-table>
        </div>

        <!-- 专线筛查 -->
        <div class="reference-section">
          <h3>|| 专线筛查</h3>
          <el-table :data="enterpriseList" border size="small">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="source" label="数据来源" width="150" align="center" />
            <el-table-column prop="beginning" label="起始地" width="200" align="center" />
            <el-table-column prop="destination" label="目的地" width="200" align="center" />
          </el-table>
        </div>

        <!-- 企业信息筛查 -->
        <div class="reference-section">
          <h3>|| 企业信息筛查</h3>
          <el-table :data="enterpriseLitigationList" border size="small">
            <el-table-column label="涉车诉讼" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.one && row.one.types === 1" type="text" @click="showLitigationDetail(1)">{{ row.one.total }} 条</el-button>
                <span v-else>暂无数据</span>
              </template>
            </el-table-column>
            <el-table-column label="涉用工合同诉讼" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.two && row.two.types === 2" type="text" @click="showLitigationDetail(2)">{{ row.two.total }} 条</el-button>
                <span v-else>暂无数据</span>
              </template>
            </el-table-column>
            <el-table-column label="涉保险纠纷" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.three && row.three.types === 4" type="text" @click="showLitigationDetail(3)">{{ row.three.total }} 条</el-button>
                <span v-else>暂无数据</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 审核操作按钮 -->
      <div class="action-buttons" v-if="!isBs">
        <el-button type="danger" @click="handleIntercept">拦截</el-button>
        <el-button type="warning" @click="handleSupplement">补充资料</el-button>
        <el-button type="success" @click="handlePass">通 过</el-button>
      </div>
    </div>

    <!-- 补充资料弹窗 -->
    <el-dialog :visible.sync="supplementDialogVisible" title="补充资料" width="450px" append-to-body>
      <el-form label-width="80px">
        <el-form-item label="补充资料">
          <el-input type="textarea" v-model="checkDescription" :rows="4" placeholder="请输入补充资料"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="supplementDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSupplement">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 审核理由弹窗 -->
    <el-dialog :visible.sync="reasonDialogVisible" :title="reasonType === 8 ? '通过理由' : '审核备注'" width="500px" append-to-body>
      <el-form label-width="80px">
        <el-form-item label="客户类型：" v-if="productName === '货运险年保'">
          <el-select v-model="customType" style="width: 150px;">
            <el-option label="普通客户" :value="1"></el-option>
            <el-option label="优质客户" :value="2"></el-option>
            <el-option label="黑名单客户" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="reasonType === 32 ? '拦截理由：' : '审核备注：'">
          <el-input type="textarea" v-model="reason" :rows="4" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="reasonDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitReason">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 诉讼详情弹窗 -->
    <el-dialog :visible.sync="litigationDialogVisible" title="详情" width="900px" append-to-body>
      <el-table :data="litigationDetails" border size="small">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="company_name" label="企业名称" width="150" align="center" />
        <el-table-column label="诉讼类型" width="120" align="center">
          <template slot-scope="{ row }">{{ row.type === 1 ? '涉车诉讼' : row.type === 2 ? '涉用工合同诉讼' : '涉保险纠纷' }}</template>
        </el-table-column>
        <el-table-column prop="case_no" label="案号" width="150" align="center" />
        <el-table-column prop="amount" label="案件金额" width="120" align="center" :formatter="moneyFormat" />
        <el-table-column prop="judge_result" label="裁判结果" width="150" align="center" show-overflow-tooltip />
        <el-table-column prop="judge_date" label="裁判日期" width="120" align="center" />
      </el-table>
      <div slot="footer">
        <el-button @click="litigationDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="previewVisible" append-to-body>
      <img :src="previewUrl" style="width: 100%;" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getUnderwriteOrderInfo, getUnderwriteManualInfo, updateUnderwriteOrderStatus } from '@/api/underwrite-order'

export default {
  name: 'OrderDetails',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [Number, String, null],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      tabIndex: 1,
      isBs: false,
      productName: '',
      // 系统核保数据
      orderInfo: {},
      preUnderwriteDetails: [],
      fileList: [],
      // 人工核保数据
      claimsOrderList: [],
      ygbOrderList: [],
      hyxOrderList: [],
      enterpriseList: [],
      enterpriseLitigationList: [],
      // 审核相关
      reasonType: null,
      reason: '',
      checkDescription: '',
      customType: 1,
      // 弹窗控制
      supplementDialogVisible: false,
      reasonDialogVisible: false,
      litigationDialogVisible: false,
      previewVisible: false,
      previewUrl: '',
      litigationDetails: []
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  watch: {
    visible(val) {
      if (val && this.orderId) {
        this.fetchData()
      } else {
        this.resetData()
      }
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        // 获取订单详情
        const res = await getUnderwriteOrderInfo({ id: this.orderId * 1 })
        if (res.err_code === 0 && res.data) {
          const d = res.data
          this.productName = d.product_name || ''
          this.orderInfo = {
            policyholder: d.policyholder || '',
            last_compensation: d.last_compensation || '',
            note: d.note || '',
            extend: d.extend || '',
            channel_name: d.channel_name || '',
            business_income: d.business_income ? (d.business_income / 10000).toFixed(2) : '',
            single_coverage: d.single_coverage ? (d.single_coverage / 10000).toFixed(2) : '',
            total_coverage: d.total_coverage ? (d.total_coverage / 10000).toFixed(2) : '',
            province: d.province || '',
            city: d.city || '',
            business_scope: d.business_scope || ''
          }
          this.preUnderwriteDetails = d.pre_underwrite_details || []
          this.fileList = d.file_list || []
          // 处理 refusal_reason
          if (d.refusal_reason && d.refusal_reason.indexOf('[') === 0) {
            const refusals = d.refusal_reason.replace(/[\s\n]/g, '')
            const parsed = JSON.parse(refusals)
            this.reason = parsed.length === 1 ? parsed[0] : parsed
          } else {
            this.reason = d.refusal_reason || ''
          }
          this.checkDescription = d.check_description || ''
        }

        // 获取人工核保参考信息
        const manualRes = await getUnderwriteManualInfo({ id: this.orderId * 1 })
        if (manualRes.err_code === 0 && manualRes.data) {
          const md = manualRes.data
          this.claimsOrderList = md.claims_order_list || []
          this.ygbOrderList = md.ygb_order_list || []
          this.hyxOrderList = md.hyx_order_list || []
          this.enterpriseList = md.enterprise_list || []
          // 处理 enterprise_litigation_list
          const litList = md.enterprise_litigation_list || []
          const list = [{ one: {}, two: {}, three: {} }]
          litList.forEach(item => {
            if (item.types === 1) list[0].one = item
            else if (item.types === 2) list[0].two = item
            else if (item.types === 4) list[0].three = item
          })
          this.enterpriseLitigationList = list
        }
      } catch (e) {
        this.$message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    // 审核操作
    handleIntercept() {
      this.reasonType = 32
      this.reason = ''
      this.reasonDialogVisible = true
    },
    handleSupplement() {
      this.reasonType = 2
      this.checkDescription = ''
      this.supplementDialogVisible = true
    },
    handlePass() {
      this.reasonType = 8
      this.reason = ''
      this.reasonDialogVisible = true
    },
    async submitSupplement() {
      if (!this.checkDescription.trim()) {
        this.$message.warning('请填写补充资料')
        return
      }
      await this.submitStatusUpdate(2, this.checkDescription)
      this.supplementDialogVisible = false
    },
    async submitReason() {
      if (!this.reason.trim()) {
        this.$message.warning('请填写审核理由')
        return
      }
      await this.submitStatusUpdate(this.reasonType, this.reason.replace(/[\s\n]/g, ''))
      this.reasonDialogVisible = false
    },
    async submitStatusUpdate(status, reason) {
      try {
        const data = {
          id: this.orderId * 1,
          status: status * 1
        }
        if (reason) {
          data.reason = reason
        }
        if (this.productName === '货运险年保') {
          data.custom_type = this.customType * 1
        }
        const res = await updateUnderwriteOrderStatus(data)
        if (res.err_code === 0) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    showLitigationDetail(type) {
      const item = this.enterpriseLitigationList[0]
      if (type === 1) {
        this.litigationDetails = item.one.enterprise_litigation || []
      } else if (type === 2) {
        this.litigationDetails = item.two.enterprise_litigation || []
      } else {
        this.litigationDetails = item.three.enterprise_litigation || []
      }
      this.litigationDialogVisible = true
    },
    previewImage(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    // 格式化函数
    scheduleFormat(row, col, cellValue) {
      const map = {
        1: '资料收集中',
        2: '定损中',
        4: '定损金额沟通中',
        8: '支付赔偿中',
        16: '已结束'
      }
      return map[cellValue] || ''
    },
    moneyFormat(row, col, cellValue) {
      if (cellValue == null) return ''
      return (cellValue / 100).toFixed(2)
    },
    dateFormat(row, col, cellValue) {
      if (!cellValue) return ''
      const d = new Date(cellValue)
      if (isNaN(d.getTime())) return ''
      const pad = n => (n < 10 ? '0' + n : n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },
    dateTimeFormat(row, col, cellValue) {
      if (!cellValue) return ''
      const d = new Date(cellValue)
      if (isNaN(d.getTime())) return ''
      const pad = n => (n < 10 ? '0' + n : n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    resetData() {
      this.tabIndex = 1
      this.orderInfo = {}
      this.preUnderwriteDetails = []
      this.fileList = []
      this.claimsOrderList = []
      this.ygbOrderList = []
      this.hyxOrderList = []
      this.enterpriseList = []
      this.enterpriseLitigationList = []
      this.reason = ''
      this.checkDescription = ''
      this.customType = 1
    },
    handleClose() {
      this.resetData()
    }
  }
}
</script>

<style lang="less" scoped>
.order-details {
  .tab-header {
    display: flex;
    border-bottom: 2px solid #FF5F3B;
    margin-bottom: 20px;
    span {
      padding: 10px 30px;
      cursor: pointer;
      background: #f5f5f5;
      border-radius: 5px 5px 0 0;
      margin-right: 5px;
      &.active {
        background: #FF5F3B;
        color: #fff;
      }
    }
  }
  .tab-content {
    padding: 10px 0;
  }
  .detail-section {
    display: flex;
    .info-left, .info-right {
      flex: 1;
      padding: 0 20px;
    }
    .info-item {
      margin-bottom: 15px;
      label {
        display: inline-block;
        width: 120px;
        text-align: right;
        margin-right: 10px;
        color: #666;
      }
    }
  }
  .result-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    th, td {
      border: 1px solid #000;
      padding: 8px;
      text-align: center;
    }
    th {
      background: #f5f5f5;
    }
  }
  .attachment-section {
    margin-top: 20px;
    .file-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-top: 10px;
    }
  }
  .manual-reference {
    .reference-section {
      margin-bottom: 25px;
      h3 {
        margin: 10px 0;
        font-size: 14px;
        color: #333;
      }
    }
  }
  .action-buttons {
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid #eee;
    margin-top: 20px;
  }
}
</style>
